import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { BorderBottom } from '@/components/uikit';
import { Address, Patient } from '@/types';
import { HeaderLabel } from './HeaderLabel';

interface Props {
  patient: Patient;
  patientAddress?: Address;
  pharmacyAddress?: string;
}

export function PatientInfo({
  patient,
  patientAddress,
  pharmacyAddress,
}: Props) {
  return (
    <Box mb="1rem" bgcolor="white" p={2} flex={1}>
      <HeaderLabel>Informasi Pasien</HeaderLabel>
      <BorderBottom />
      <Typography style={{ fontSize: 14, opacity: 0.7, marginTop: 16 }}>
        Nama Pasien
      </Typography>
      <Typography>{patient.full_name}</Typography>
      <Typography style={{ fontSize: 14, opacity: 0.7, marginTop: 14 }}>
        Nomor HP Pasien
      </Typography>
      <Typography>{patient.phone_number}</Typography>
      <Typography style={{ fontSize: 14, opacity: 0.7, marginTop: 14 }}>
        Alamat Pengiriman
      </Typography>

      {pharmacyAddress && (
        <Typography>Diambil di {pharmacyAddress} (Self Pickup)</Typography>
      )}

      {patientAddress && (
        <>
          {patientAddress.first_line && (
            <Typography>{patientAddress.first_line}</Typography>
          )}
          <Typography>{patientAddress.second_line}</Typography>
        </>
      )}

      <Typography style={{ fontSize: 14, opacity: 0.7, marginTop: 14 }}>
        Detail Lokasi
      </Typography>
      <Typography>{patientAddress?.note || '-'}</Typography>
    </Box>
  );
}
